import { __awaiter } from '../../../../../_virtual/_tslib.js';
import { useState, useCallback, useEffect } from 'react';

const usePromise = (fetcher, deps = []) => {
    const [state, setState] = useState({
        active: false,
    });
    const fetch = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        setState({
            active: true,
        });
        try {
            let data;
            const fetchData = fetcher();
            if (fetchData instanceof Promise) {
                data = yield fetchData;
            }
            else {
                data = fetchData;
            }
            setState({
                active: false,
                data,
            });
        }
        catch (error) {
            setState({
                active: false,
                error: error,
            });
        }
    }), [setState, fetcher]);
    useEffect(() => {
        fetch();
    }, deps);
    return Object.assign(Object.assign({}, state), { isLoading: state.active });
};

export { usePromise };
